import { type GuardPolicy } from '../constants';
export const InvalidPolicyErrorName = 'InvalidPolicyError';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export default class InvalidPolicyError extends Error {
	constructor(policy: GuardPolicy, method: string) {
		super(`Method '${method}' cannot be called with policy '${policy}'.`);
		this.name = InvalidPolicyErrorName;
	}
}
